<template>
  <div class="StyleSelectMenu">
    <header>
      <img class="logo" src="icon/brandc_logo.svg" width="230" height="32" />
      ウェブ価格表
      <span class="note">表示価格には消費税は含まれていません</span>
    </header>
    <h1 class="title">
      {{ routeTitle || title }}
      <span class="sub">{{ name }}</span>
    </h1>
    <div class="transition-wrapper leftover">
      <slide-transition>
        <keep-alive include="SelectItem">
          <router-view :key="$route.params.itemId" />
        </keep-alive>
      </slide-transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SlideTransition from '@/components/SlideTransition';

export default {
  name: 'StyleSelectMenu',
  components: {
    SlideTransition
  },
  props: {
    routeTitle: {
      type: String
    }
  },
  // data() {
  //   return {
  //     transitionName: 'slide-left'
  //   }
  // },
  // beforeRouteUpdate(_to, from, next) {
  //   this.transitionName = from.path !== '/' ? 'slide-right' : 'slide-left'
  //   next()
  // },
  // components: {
  //   StyleSelectBar
  // },
  computed: mapGetters(['title', 'name'])
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.StyleSelectMenu {
  display: flex;
  flex-flow: column nowrap;
  min-height: 100%;
  background: #fff;
}
header {
  flex: 0 0 auto;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: clamp(12px, 10%, 32px) 10%;
  width: 100%;
  /* min-height: 15vh; */
  /* min-height: 160px; */
  font-size: clamp(14px, calc(16 / 320 * 100vw), 18px);
  font-weight: 500;
  color: #fff;
  background-color: var(--main-color);
  border-bottom: 2px solid var(--accent-color);
}
header > img {
  display: block;
  margin-bottom: 16px;
  /* width: 240px; */
  max-width: 100%;
}
header .note {
  display: inline-block;
  margin-block-start: 12px;
  padding: 5px 8px 4px;
  font-size: 0.7em;
  border: 1px solid #fff;
}
header .logo {
  inline-size: 360px;
  block-size: auto;
  max-inline-size: 100%;
}
.title {
  margin: 0;
  padding: 12px;
  padding-left: env(safe-area-inset-left);
  width: 100%;
  /* ugly */
  text-align: center;
  letter-spacing: 0.5px;
  font-size: clamp(18px, 2.4cqi, 24px);
  font-weight: 500;
  background-color: #fff;
  border-bottom: 12px solid var(--accent-color);
}
.title .sub {
  display: block;
  font-size: 0.75em;
}
.leftover {
  flex: 1 1 auto;
  background-color: #fff;
}
.transition-wrapper {
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/StyleSelectMenu.vue